
<div class="login-container">
   
  <div class="login-wrapper">
    <div class="login-form-section">
       <nz-spin [nzSpinning]="loading">
      <div class="login-content">
        <div class="title-section">
          <img src="assets/icon/icono-sgmm.svg" class="icon" alt="icon">
          <h1 class="main-title">Seguro de Gastos Médicos Menores</h1>
          <!-- <hr class="title-divider"> -->
        </div>
        <br>
        <div class="welcome-section">
          <h2 class="welcome-title">¡Bienvenido!

          </h2>
          <p class="welcome-subtitle">Inicia sesión con tu cuenta existente</p>
        </div>
        <br>
        <br>
          <button type="submit" class="login-button"
            (click)="loginRedirect()"
          >
            Acceder 
            <i
              nz-icon
              nzType="arrow-right"
              nzTheme="outline"
              style="cursor: pointer; color: #FFFFFF; margin-right: 8px"
              title="Ver detalles"
            ></i>
          </button>
         <br>
         <!-- <br>
          <button type="submit" class="login-button"
            (click)="showModal()"
          >
            Acceder con usuario y contraseña
            <i
              nz-icon
              nzType="arrow-right"
              nzTheme="outline"
              style="cursor: pointer; color: #FFFFFF; margin-right: 8px"
              title="Ver detalles"
            ></i>
          </button> -->
          
        <div class="app-version">
          <p>Versión {{ appVersion }}</p>
        </div>
      </div>
      </nz-spin>
    </div>
    <div class="login-image-section">
      <div class="image-container">
        <img 
          src="assets/images/background-login.jpg" 
          class="login-image">
      </div>
    </div>
  </div>
</div>

<!-- <nz-modal 
  [(nzVisible)]="isModalVisible" 
  nzTitle="Login" 
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
  [nzOkLoading]="modalLoading"
  nzOkText="Iniciar Sesión"
  nzCancelText="Cancelar">
  
  <ng-container *nzModalContent>
    <form>
      <div class="modal-form-group">
        <label for="email">Email:</label>
        <nz-input-group>
          <input 
            nz-input 
            type="email" 
            id="email"
            placeholder="Ingresa tu email" 
            [(ngModel)]="email" 
            name="email"
            required>
        </nz-input-group>
      </div> -->
      
      <!-- <div class="modal-form-group">
        <label for="password">Password:</label>
        <nz-input-group>
          <input 
            nz-input 
            type="password" 
            id="password"
            placeholder="Ingresa tu contraseña" 
            [(ngModel)]="password" 
            name="password"
            required>
        </nz-input-group>
      </div> -->
    <!-- </form>
  </ng-container>
  <div *nzModalFooter>
        <button nz-button class="login-button2" nzType="primary" (click)="loginManual()">Aceptar</button>
      </div>
</nz-modal> -->